module.exports = __webpack_public_path__ + "static/media/creator_icon.5962762b.png";